import UsersScreen from './UsersScreen';

export default UsersScreen;
